import styled from 'styled-components';
import { IconButton, Collapse } from "@material-ui/core";
import { AttachFile, InsertEmoticon, PlayArrow, VoiceChat } from "@material-ui/icons";
import { IconPanelProps } from "./index";

export const StyledIconButton = styled(IconButton)`
  && {
    padding: 8px;
    border-radius: unset;
  }
`;

export const StyledAttachFileIcon = styled(AttachFile)`
  
`;

export const StyledEmojiIcon = styled(InsertEmoticon)`
  
`;

export const StyledVoiceChatIcon = styled(VoiceChat)`
  
`;

export const StyledCollapse = styled(Collapse)<{index: number, offset: boolean}>`
  position: absolute;
  bottom: 40px;
  left: ${props => (props.index - 0.5) * 40 + 10 + (props.offset && props.index === 0 ? 20 : 0)}px;
  box-shadow: 0 4px 20px 0 rgba(0,0,0,.1), 0 8px 17px 0 rgba(0,0,0,.16);
  width: 290px;
  z-index: 10000;
  border-radius: 7px;
  & .MuiCollapse-wrapperInner {
    background-color: #F0F0F0;
  }
`;

export const StyleArrowIcon = styled(PlayArrow)<any>`
  transform: rotate(90deg);
  color: #F0F0F0;
  position: absolute;
  top: 240px;
  left: ${props => props.offset ? -2 : 18}px;
  z-index: 10000;
`; 

export const Container = styled.div<{styles?: IconPanelProps }>`
  background-color: ${props => props.styles?.backgroundColor};
  ${StyledAttachFileIcon} {
    color:${props => props.styles?.iconsColor};
  }
  ${StyledEmojiIcon} {
    color:${props => props.styles?.iconsColor};
  }
  ${StyledVoiceChatIcon} {
    color:${props => props.styles?.iconsColor};
  }
  ${StyledIconButton}{
    :hover{
      background-color: ${props => props.styles?.iconsBackgroundHoverColor || 'unset'}
    }
  }
  height: 40px;
  display: flex;
  position: relative;
`;